<template>
  <AppHeader />
  <BaseMain>
    <v-container class="py-6 py-md-8">
      <BackButton />
      <slot />
    </v-container>
  </BaseMain>
  <AppFooter />
</template>
